/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{glsl as o}from"../shaderModules/glsl.js";function c(c){c.vertex.code.add(o`vec4 offsetBackfacingClipPosition(vec4 posClip, vec3 posWorld, vec3 normalWorld, vec3 camPosWorld) {
vec3 camToVert = posWorld - camPosWorld;
bool isBackface = dot(camToVert, normalWorld) > 0.0;
if (isBackface) {
posClip.z += 0.0000003 * posClip.w;
}
return posClip;
}`)}export{c as Offset};
